module.exports = __webpack_public_path__ + "static/media/lock_icon.c225b912.svg";